var render = function render(){var _vm=this,_c=_vm._self._c;return _c('channel-selector',{class:{ inactive: !_vm.isActive },attrs:{"title":_vm.channel.name,"src":_vm.getChannelThumbnail()},on:{"click":_vm.onItemClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }